import type { FileDataInterface } from '../types/form-types';
import { fileDict } from './files.dicts';

export const eubankOfferFinancedItems: FileDataInterface[] = [
  {
    key: 'AREST',
    label: fileDict.AREST
  }
];

export const financingItems: FileDataInterface[] = [
  {
    key: 'KASKO',
    label: fileDict.KASKO
  },
  {
    key: 'TEHP',
    label: fileDict.TEHP
  },
  {
    key: 'DSCR',
    label: fileDict.DSCR
  },
  {
    key: 'VNES',
    label: fileDict.VNES
  },
  {
    key: 'EM079',
    label: fileDict.EM079
  },
  {
    key: 'EM080',
    label: fileDict.EM080
  },
  {
    key: 'IDCD',
    label: fileDict.IDCD
  },
  {
    key: 'doc47',
    label: fileDict.doc47
  },
  {
    key: 'KVPV',
    label: fileDict.KVPV
  },
  {
    key: 'AREST',
    label: fileDict.AREST
  }
];
